import Script from 'react-load-script';
import React, { useState } from 'react';
import { addPageAlert } from '../../../PortalStore/Actions/PageAlertActions';
import { string, element } from 'prop-types';
const GMapContainer = ({ apiKey, children }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=geometry,drawing,places`;

    const handleLoadError = () => {
        this.props.dispatch(addPageAlert({ level: 'error', title: 'Google Maps failed to load', message: 'Please reload the page and try again' }));
    }

    return (
        <div>
            <Script
                url={url}
                onError={(err) => {
                    setError(err)
                }}
                onLoad={() => {
                    setLoaded(true)
                }}
            />
            {
                loaded ? children : 'loading....'
            }
            {
                error ? handleLoadError() : ''
            }
        </div>
    )
}
GMapContainer.propTypes = {
    apiKey: string.isRequired,
    children: element.isRequired,
};
export default GMapContainer;